module.exports = __webpack_public_path__ + "static/media/4.120be1a0.png";